import { NivosUser } from 'types/user'

const hasPermission = (user: NivosUser, code: string): boolean => {
  for (let i = 0; i < user.groups.length; i++) {
    const hit = user.groups[i].permissions.filter(
      permission => permission.codename === code
    )
    if (hit !== undefined && hit.length > 0) {
      return true
    }
  }
  return false
}

const hasPermissions = (user: NivosUser, codes: string[]): boolean => {
  for (let i = 0; i < codes.length; i++) {
    if (!hasPermission(user, codes[i])) {
      return false
    }
  }
  return true
}

export { hasPermission, hasPermissions }
